/** Addresses that cannot name anything: a design id that is not a UUID is answered "not found" by the dashboard itself,
 * without asking the API (whose preflight for such a path failed, leaving the page on "Loading…": live test EX-07). */
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isUuid(value: string | undefined | null): boolean {
  return !!value && UUID.test(value);
}
